module.exports = __webpack_public_path__ + "img/small.8ed63a04.jpg";